export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "last_updated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last updated"])},
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
        "new_training_standard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New training standard"])},
        "dropdown": {
          "standard_management": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Standard Management"])},
          "manage_terms_of_service": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage Terms of Service"])},
          "manage_resources": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage Resources"])}
        },
        "program_standard_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Program Standards"])},
        "training_standard_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Training Standards"])},
        "exam_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exams"])},
        "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There are no program standards to display"])},
        "no_search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your search returned 0 matches."])}
      },
      "fr": {
        "last_updated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dernière mise à jour"])},
        "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])},
        "new_training_standard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouvelle norme de formation"])},
        "dropdown": {
          "standard_management": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion Standard"])},
          "manage_terms_of_service": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gérer les conditions de service"])},
          "manage_resources": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gérer les ressources"])}
        },
        "program_standard_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Normes du programme"])},
        "training_standard_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Normes de formation"])},
        "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il n’y a pas de norme de formation à afficher."])},
        "no_search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Votre recherche a renvoyé 0 résultats."])}
      }
    }
  })
}